import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import Dial from '~/components/Dial.vue';
import SideScroll from '~/components/SideScroll.vue';
import WebpPicture from '~/components/WebpPicture.vue';
import TransitionExpand from '~/components/collapse/TransitionExpand.vue';
import debounce from '~/utilities/debounce.js';
export default {
  name: 'comment-form',
  components: {
    Dial: Dial,
    SideScroll: SideScroll,
    WebpPicture: WebpPicture,
    TransitionExpand: TransitionExpand
  },
  props: ['user', 'modelName', 'modelId', 'isDynamic', 'comment', 'thread', 'type', 'isEditor', 'chatMode', 'draft'],
  data: function data() {
    return {
      message: '',
      sending: false,
      focused: false,
      images: [],
      currentImageIndex: 0,
      draftId: null,
      uploadingImages: false,
      draggingFile: false,
      glowDropzone: false
    };
  },
  computed: {
    appStore: function appStore() {
      return useAppStore();
    },
    replyTo: function replyTo() {
      return this.comment;
    },
    isReport: function isReport() {
      return this.type == 'report';
    },
    isHide: function isHide() {
      return this.type == 'hide';
    },
    sendHelper: function sendHelper() {
      if (this.appStore.os == 'Mac OS') return '⌘ + Return';
      return 'Ctrl + Enter';
    },
    placeholder: function placeholder() {
      if (this.isReport) return this.$t('addReport');
      if (this.chatMode) return this.$t('addReply');
      return this.$t('addComment');
    },
    isLastImage: function isLastImage() {
      return this.currentImageIndex >= this.images.length - 1;
    },
    isFirstImage: function isFirstImage() {
      return this.currentImageIndex <= 0;
    },
    hasText: function hasText() {
      if (!this.message) return false;
      return this.message.trim().length > 0;
    },
    isEmpty: function isEmpty() {
      var _this$images;
      return !this.hasText && !((_this$images = this.images) !== null && _this$images !== void 0 && _this$images.length);
    }
  },
  watch: {
    isHide: function isHide(val) {
      if (val) this.setHideText();
    },
    message: function message(val) {
      this.debounceSaveDraft();
    },
    draft: function draft() {
      this.syncDraft();
    },
    images: function images() {
      // Add or hide arrows in sidescroll
      if (this.$refs.sideScroll) this.$refs.sideScroll.arrowCheck();
    }
  },
  created: function created() {
    if (this.draft) this.syncDraft();
  },
  mounted: function mounted() {
    if (this.isDynamic) this.setFocus();
    if (this.isEditor) this.message = this.comment.text;

    // autosize(document.getElementsByClassName('autosize'));

    if (this.type == 'hide') this.setHideText();
    window.addEventListener('dragover', this.dragoverHandle);
    window.addEventListener('dragleave', this.dragendHandle);
    window.addEventListener('dragend', this.dragendHandle);
    window.addEventListener('drop', this.dragendHandle);
  },
  methods: {
    dragoverHandle: function dragoverHandle(event) {
      // event.preventDefault();
      var dt = event.dataTransfer;
      if (dt && dt.files.length > 0) {
        this.draggingFile = true;
      } else if (dt.items && _toConsumableArray(dt.items).some(function (item) {
        return item.kind === "file";
      })) {
        this.draggingFile = true;
      } else {
        this.draggingFile = false;
      }
    },
    dragendHandle: function dragendHandle(event) {
      if (event.type == 'dragleave') {
        // If relatedTarget is null or "HTML", it likely means the cursor left the window.
        if (!event.relatedTarget || event.relatedTarget.nodeName === "HTML") {
          this.draggingFile = false;
        }
      } else {
        this.draggingFile = false;
      }
    },
    syncDraft: function syncDraft() {
      if (this.draft) {
        if (!this.focused) this.message = this.draft.text;
        if (!this.uploadingImages) this.images = this.draft.images || [];
        this.draftId = this.draft.id;
      } else {
        this.message = '';
        this.images = [];
      }
    },
    setHideText: function setHideText() {
      this.message = "Ваш коментар було приховано в зв'язку з тим, що його сенс не має відношення до тексту матеріалу, під яким він був залишений.";
    },
    submitHandler: function submitHandler(e) {
      if ((e.metaKey || e.ctrlKey) && e.keyCode == 13) {
        this.submit();
      }
    },
    focus: function focus() {
      this.focused = true;
      if (!this.$auth.user) {
        this.$modalityStore.openModal({
          type: 'drawer',
          name: 'login',
          message: 'login.401.default'
        });
        return;
      }
    },
    debounceSaveDraft: debounce(function () {
      this.saveDraft();
    }, 700),
    saveDraft: function saveDraft() {
      var _this = this;
      if (this.isEditor) return; // No drafts for edit

      var params = {
        _csrf: this.appStore.csrfToken,
        postId: this.modelId,
        postModel: this.modelName,
        text: this.message,
        parent: this.thread,
        replyTo: this.replyTo
      };
      this.$socket.post('/comment/draft', params, function (resData, jwres) {
        /***********************
         * @todo handle error
        ************************/
        if (jwres.statusCode !== 200) {
          console.log(jwres);
          return console.error('error');
        }
        _this.draftId = resData.id;
      });
    },
    submit: function submit(event) {
      var _this2 = this;
      if (!this.$auth.user) {
        this.$modalityStore.openModal({
          type: 'drawer',
          name: 'login',
          message: 'login.401.default'
        });
        return;
      }

      // Prevent empty string sending or multiple requests
      if (this.isEmpty || this.sending || this.uploadingImages) return true;
      this.sending = true;
      var url = this.type ? "/comment/".concat(this.type) : '/comment/create';
      var params = {
        _csrf: this.appStore.csrfToken,
        postId: this.modelId,
        postModel: this.modelName,
        text: this.message,
        parent: this.thread,
        replyTo: this.replyTo
      };
      this.$socket.post(url, params, function (resData, jwres) {
        /***********************
         * @todo handle error
        ************************/
        if (jwres.statusCode !== 200) {
          console.log(jwres);
          return console.error('error');
        }
        switch (_this2.type) {
          case 'hide':
            break;
          case 'report':
            _this2.$emit('placeReports', {
              reports: resData,
              commentId: _this2.replyTo,
              parentId: _this2.thread
            });
            break;
          default:
            _this2.$emit('placeComments', resData);
            _this2.$emit('increaseLength');
            break;
        }

        // Remove form
        _this2.$emit('commentSent');
        _this2.sending = false;
        _this2.message = '';
        _this2.images = [];
        _this2.draftId = null;
      });
    },
    update: function update() {
      var _this3 = this;
      var params = {
        _csrf: this.appStore.csrfToken,
        id: this.comment.id,
        text: this.message
      };
      this.$socket.post('/comment/update', params, function (resData, jwres) {
        /***********************
         * @todo handle error
        ************************/
        if (jwres.statusCode !== 200) {
          _this3.$emit('cancel');
          console.log(jwres);
          return console.error('error');
        }
        _this3.$emit('updateComment', _this3.message);
      });
    },
    setFocus: function setFocus() {
      if (this.$refs.textarea) this.$refs.textarea.$el.focus();
    },
    handleClick: function handleClick(e) {
      if (['BUTTON', 'A', 'TEXTAREA', 'INPUT'].includes(e.target.tagName)) return;
      if (e.target.closest("a, button", "textarea", "input")) return;
      this.setFocus();
    },
    selectFiles: function selectFiles() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },
    clearFileInput: function clearFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    addImage: function addImage(e) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var toast, allowedFiles, _loop, _ret, i, imagesToRemove, _loop2, _i, _i2;
        return regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              toast = {
                title: _this4.$t('page.module.practice.toast.error'),
                text: _this4.$t('page.module.practice.upload.toast.cantUpload'),
                icon: 'icon-ic-dismiss'
              };
              if (!(!_this4.$refs.fileInput || !_this4.$refs.fileInput.files.length)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", _this4.clearFileInput());
            case 3:
              _this4.uploadingImages = true;
              allowedFiles = ['image/jpg', 'image/jpeg', 'image/png']; // Validate images and show them
              _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
                var file, obj, checkImageWidth, imgWidth, filename;
                return regeneratorRuntime.wrap(function _loop$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      file = _this4.$refs.fileInput.files[i];
                      if (!(_this4.images.length > 9)) {
                        _context2.next = 6;
                        break;
                      }
                      toast.title = _this4.$t('overLimitTitle', {
                        name: file.name
                      });
                      toast.text = _this4.$t('overLimitText');
                      _this4.$toastStore.add(toast);
                      return _context2.abrupt("return", 0);
                    case 6:
                      if (allowedFiles.includes(file.type)) {
                        _context2.next = 11;
                        break;
                      }
                      toast.title = _this4.$t('page.module.practice.upload.toast.invalidFormat', {
                        name: file.name
                      });
                      toast.text = _this4.$t('page.module.practice.upload.toast.invalidFormaText', {
                        formats: 'PNG, JPEG'
                      });
                      _this4.$toastStore.add(toast);
                      return _context2.abrupt("return", 0);
                    case 11:
                      if (!(file.size > 10485760)) {
                        _context2.next = 15;
                        break;
                      }
                      toast.text = _this4.$t('page.module.practice.upload.toast.oversize', {
                        name: file.name
                      });
                      _this4.$toastStore.add(toast);
                      return _context2.abrupt("return", 0);
                    case 15:
                      obj = {
                        filename: null,
                        createdAt: new Date(),
                        progress: 0,
                        loading: true,
                        deliting: false,
                        file: file,
                        src: null
                      }; // Image validation
                      checkImageWidth = new Promise(function (resolve, reject) {
                        var image = new Image();
                        var _URL = window.URL || window.webkitURL;
                        image.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                resolve(this.width);
                              case 1:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee, this);
                        }));
                        image.src = _URL.createObjectURL(file);
                        obj.src = image.src;
                      });
                      _context2.next = 19;
                      return checkImageWidth;
                    case 19:
                      imgWidth = _context2.sent;
                      if (!(imgWidth > 4000)) {
                        _context2.next = 25;
                        break;
                      }
                      toast.title = _this4.$t('overWidthTitle', {
                        name: file.name
                      });
                      toast.text = _this4.$t('overWidthText');
                      _this4.$toastStore.add(toast);
                      return _context2.abrupt("return", 0);
                    case 25:
                      filename = file.name.replace(/[/\\?%*:|"<>]/g, '-'); // Replace forbidden symbols
                      obj.filename = filename.replace(/[\s]/g, ' '); // Remplace all whitespaces to regular space

                      // Push to images
                      _this4.images.push(obj);
                    case 28:
                    case "end":
                      return _context2.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 7:
              if (!(i < _this4.$refs.fileInput.files.length)) {
                _context4.next = 15;
                break;
              }
              return _context4.delegateYield(_loop(), "t0", 9);
            case 9:
              _ret = _context4.t0;
              if (!(_ret === 0)) {
                _context4.next = 12;
                break;
              }
              return _context4.abrupt("continue", 12);
            case 12:
              i++;
              _context4.next = 7;
              break;
            case 15:
              imagesToRemove = [];
              _loop2 = /*#__PURE__*/regeneratorRuntime.mark(function _loop2(_i) {
                var image, formData;
                return regeneratorRuntime.wrap(function _loop2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      image = _this4.images[_i];
                      if (image.loading) {
                        _context3.next = 3;
                        break;
                      }
                      return _context3.abrupt("return", 1);
                    case 3:
                      formData = new FormData();
                      formData.append('postModel', _this4.modelName);
                      formData.append('postId', _this4.modelId);
                      if (_this4.draft) formData.append('id', _this4.draft.id);
                      if (_this4.thread) formData.append('parent', _this4.thread);
                      formData.append('image', image.file, image.filename);
                      _context3.next = 11;
                      return _this4.$axios.post('/comment/uploadImage', formData, {
                        onUploadProgress: function onUploadProgress(uploadEvent) {
                          _this4.images[_i].progress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                        }
                      }).then(function (res) {
                        var image = res.data.image;
                        image.loading = false;
                        image.progress = 100;
                        _this4.images.splice(_i, 1, image);
                      }).catch(function (error) {
                        var res = error.response ? error.response.data : null;
                        if (res && res.message) toast.text = res.message;
                        _this4.$toastStore.add(toast);
                        imagesToRemove.push(_i);
                      });
                    case 11:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop2);
              });
              _i = 0;
            case 18:
              if (!(_i < _this4.images.length)) {
                _context4.next = 25;
                break;
              }
              return _context4.delegateYield(_loop2(_i), "t1", 20);
            case 20:
              if (!_context4.t1) {
                _context4.next = 22;
                break;
              }
              return _context4.abrupt("continue", 22);
            case 22:
              _i++;
              _context4.next = 18;
              break;
            case 25:
              // Remove images in reverse order
              for (_i2 = imagesToRemove.length - 1; _i2 >= 0; _i2--) {
                _this4.images.splice(imagesToRemove[_i2], 1);
              }

              // Clear file input
              _this4.clearFileInput();
              _this4.setFocus();
              _this4.uploadingImages = false;
            case 29:
            case "end":
              return _context4.stop();
          }
        }, _callee2);
      }))();
    },
    removeImage: function removeImage(image) {
      var _this5 = this;
      if (image.deliting) return true;
      image.deliting = true;
      this.$axios.post('/comment/removeImage', {
        id: image.id,
        comment: this.draft.id
      }).then(function () {
        // let index = this.files.findIndex(o => o.id == file.id);
        // if (index >= 0) this.files.splice(index, 1);
      }).catch(function (error) {
        var res = error.response ? error.response.data : null;
        var toast = {
          title: _this5.$t('page.module.practice.toast.error'),
          text: _this5.$t('page.module.practice.upload.toast.cantDelete'),
          icon: 'icon-ic-dismiss'
        };
        if (res && res.message) toast.text = res.message;
        _this5.$toastStore.add(toast);
        image.deliting = false;
      });
    },
    nextImage: function nextImage() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex >= this.images.length - 1) {
        return this.currentImageIndex = this.images.length - 1;
      }
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex++;
    },
    prevImage: function prevImage() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex <= 0) return this.currentImageIndex = 0;
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex--;
    },
    openGallery: function openGallery(index) {
      this.$emit('openGallery', {
        gallery: this.images,
        index: index
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      window.removeEventListener('dragover', this.dragoverHandle);
      window.removeEventListener('dragleave', this.dragendHandle);
      window.removeEventListener('dragend', this.dragendHandle);
      window.removeEventListener('drop', this.dragendHandle);
    }
  }
};